import { LocalMenuItem } from "@base/hooks/useLocalApp/useLocalApp";

const local_menu_items: LocalMenuItem[] = [
  {
    key: "/",
    label: "Inicio",
    icon: "ant-design:home-outlined",
    visible: true,
  },
  {
    key: "/entregas",
    label: "Mis Entregas",
    icon: "lucide:archive-restore",
    visible: true,
  },
  {
    key: "/expediente",
    label: "Expediente",
    icon: "lucide:file-stack",
    visible: true,
  },
  {
    key: "/perfil",
    label: "Mi Perfil",
    icon: "lucide:user",
    visible: true,
  },
];

export default local_menu_items;
